module.exports = __webpack_public_path__ + "static/media/mike.a5d7e20d.png";